import { useMemo } from 'react';
import PropTypes from 'prop-types';

import useDetailTable from '#/hooks/table/useDetailTable';
import DetailTable from '#/modules/commonComponents/table/DetailTable';
import { buildPurchaseOrderLineColumns } from '#/modules/srmMgmt/purchaseOrder/data/purchaseOrderLineColumns';

const PurchaseOrderLinesSection = ({ lines = [] }) => {
  const columns = useMemo(() => buildPurchaseOrderLineColumns(), []);
  const rows = useMemo(
    () => (lines ?? []).map((line, index) => ({
      ...line,
      id: line?.mtr?.id
        ? `${line.mtr.id}-${index}`
        : `po-line-${index}`,
    })),
    [lines],
  );

  const detailTableState = useDetailTable(rows, columns, {
    enableExpanding: false,
    getRowId: (row) => String(row.id),
  });

  if (rows.length === 0) {
    return <p className="px-4 py-5 text-sm text-muted-foreground">尚無資料</p>;
  }

  return (
    <div className="detail-table-container">
      <DetailTable
        state={detailTableState}
        containerClassName="detail-table-scroll--section-embedded"
        tableClassName="detail-table--flat-lines"
      />
    </div>
  );
};

PurchaseOrderLinesSection.propTypes = {
  lines: PropTypes.arrayOf(PropTypes.object),
};

export default PurchaseOrderLinesSection;
